const intervaleList = [
  { label: 'Diario', value: '1d' },
  { label: 'Semanal', value: '1w' },
  // { label: 'Mensual', value: '1M' },
]

export { intervaleList }